import {Injectable} from '@angular/core';
import {ToastrService, ToastConfig} from "ngx-toastr";

@Injectable()
export class ToastService{

  constructor(public toastr: ToastrService) {
  }

  success(msg?: any, optionOverRide:ToastConfig = {}) {
    return this.toastr.success(msg, '', optionOverRide);
  }

  error(msg?: any, optionOverRide:ToastConfig = {}, title="") {
      optionOverRide.enableHtml = true;
      var msgs="";
      if(Array.isArray(msg) && msg.length>1){
          let a = 0;
          for(let x of msg){
              msgs += "<strong>"+ (++a) +"</strong>" +". "+ x +"<br>";
          }
          return this.toastr.error(msgs, '', optionOverRide);
      } else if(Array.isArray(msg) && msg.length==1){
          return this.toastr.error(msg[0], '', optionOverRide)
      } else {
          return this.toastr.error(msg, '', optionOverRide);
      }
  }

  warning(msg?: any, optionOverRide:ToastConfig = {}) {
      optionOverRide.enableHtml = true;
    return this.toastr.warning(msg, '', optionOverRide);
  }

  info(msg?: any, optionOverRide:ToastConfig = {}) {
      optionOverRide.enableHtml = true;
      return this.toastr.info(msg,"", optionOverRide);
  }
  clearToast(toastId){
      this.toastr.clear(toastId);
  }

}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/toast.service.ts